"use client";

// src/components/default/eye-open.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var EyeOpenIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `EyeOpenIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `EyeOpenIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            d: "M10.0019 13.1475C10.8767 13.1475 11.6197 12.8413 12.2308 12.2289C12.8419 11.6166 13.1474 10.873 13.1474 9.99817C13.1474 9.12337 12.8413 8.38042 12.2289 7.76931C11.6165 7.1582 10.8729 6.85264 9.99813 6.85264C9.12334 6.85264 8.38039 7.15882 7.76928 7.77119C7.15817 8.38356 6.85261 9.12715 6.85261 10.002C6.85261 10.8767 7.15879 11.6197 7.77115 12.2308C8.38353 12.8419 9.12712 13.1475 10.0019 13.1475ZM10 12.0001C9.44447 12.0001 8.97225 11.8056 8.58336 11.4167C8.19447 11.0278 8.00003 10.5556 8.00003 10.0001C8.00003 9.44451 8.19447 8.97228 8.58336 8.58339C8.97225 8.19451 9.44447 8.00006 10 8.00006C10.5556 8.00006 11.0278 8.19451 11.4167 8.58339C11.8056 8.97228 12 9.44451 12 10.0001C12 10.5556 11.8056 11.0278 11.4167 11.4167C11.0278 11.8056 10.5556 12.0001 10 12.0001ZM10 15.5834C8.30132 15.5834 6.73509 15.1328 5.30134 14.2316C3.86757 13.3304 2.71694 12.1443 1.84942 10.6731C1.77998 10.5674 1.7327 10.4588 1.70759 10.3474C1.68248 10.236 1.66992 10.1217 1.66992 10.0045C1.66992 9.88721 1.68248 9.77143 1.70759 9.65712C1.7327 9.5428 1.77998 9.43276 1.84942 9.327C2.71694 7.85585 3.86757 6.66969 5.30134 5.76852C6.73509 4.86734 8.30132 4.41675 10 4.41675C11.6987 4.41675 13.265 4.86734 14.6987 5.76852C16.1325 6.66969 17.2831 7.85585 18.1506 9.327C18.2201 9.43276 18.2674 9.54134 18.2925 9.65273C18.3176 9.7641 18.3301 9.87842 18.3301 9.99567C18.3301 10.1129 18.3176 10.2287 18.2925 10.343C18.2674 10.4573 18.2201 10.5674 18.1506 10.6731C17.2831 12.1443 16.1325 13.3304 14.6987 14.2316C13.265 15.1328 11.6987 15.5834 10 15.5834ZM10 14.5001C11.5556 14.5001 12.9931 14.0973 14.3125 13.2917C15.632 12.4862 16.6459 11.3889 17.3542 10.0001C16.6459 8.61117 15.632 7.51395 14.3125 6.70839C12.9931 5.90284 11.5556 5.50006 10 5.50006C8.44447 5.50006 7.00697 5.90284 5.68753 6.70839C4.36808 7.51395 3.35419 8.61117 2.64586 10.0001C3.35419 11.3889 4.36808 12.4862 5.68753 13.2917C7.00697 14.0973 8.44447 14.5001 10 14.5001Z"
          }
        )
      )
    );
  }
);
export {
  EyeOpenIcon
};
